import { type ForwardedRef, forwardRef } from 'react';

import { AvartarType } from '@/components/Avatar/avatarConst';
import ProfileAvatar from '@/components/Avatar/ProfileAvatar';
import { MotionDiv } from '@/components/Common/MotionDiv/MotionDiv';
import useUserStore from '@/stores/UserStore';

type Props = {
  text: string;
};

const QuestionMessage = (props: Props, ref: ForwardedRef<HTMLDivElement>) => {
  const user = useUserStore((state) => state.user);
  if (!user) return null;
  return (
    <div className="self-end flex items-start gap-3.5">
      <MotionDiv
        className="bg-gray-200 rounded-4xl py-2.5 px-4.5 max-w-160 text-gray-800 break-all whitespace-pre-wrap"
        ref={ref}
      >
        {props.text}
      </MotionDiv>
      <div className="py-1.5">
        <ProfileAvatar
          type={AvartarType.MEMBER}
          text={user.user_id}
          size={36}
          avatarFontSize="16px"
        />
      </div>
    </div>
  );
};

const forwardRefQuestionMessage = forwardRef(QuestionMessage);

export { forwardRefQuestionMessage as QuestionMessage };
